var _g, _g2, _g3, _g4, _g5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 34.1 43.1",
    enableBackground: "new 0 0 34.1 43.1",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BB9158",
    d: "M16.6,43.1c-0.4,0-0.7-0.2-0.9-0.6c-0.2-0.5,0-1.1,0.5-1.3c0.1,0,8.4-3.9,12-10.3c2.2-4,2.8-11.2,2.8-16.4 c0-0.6,0.4-1,1-1c0.6,0,1,0.5,1,1c-0.1,5.5-0.6,13-3.1,17.4c-3.9,7-12.6,11-12.9,11.2C16.9,43,16.8,43.1,16.6,43.1z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BB9158",
    d: "M16.7,28c-0.3,0-0.6-0.1-0.8-0.3l-6.5-7.8c-0.4-0.4-0.3-1,0.1-1.4c0.4-0.4,1.1-0.3,1.4,0.1l5.6,6.9l15.6-22 c0.3-0.5,0.9-0.6,1.4-0.2c0.5,0.3,0.6,0.9,0.2,1.4l-16.4,23C17.4,27.9,17.1,28,16.7,28C16.7,28,16.7,28,16.7,28z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BB9158",
    d: "M16.5,43.1c-0.1,0-0.3,0-0.4-0.1c-0.4-0.2-9.1-4.2-13-11.2c-4.2-7.5-2.9-24-2.9-24.7c0-0.5,0.5-0.9,1-0.9 c0.1,0,10.4-0.2,15-5.7c0.4-0.4,1-0.5,1.4-0.1c0.4,0.4,0.5,1,0.1,1.4C13.4,7,5,8,2.1,8.1c-0.2,3.5-0.7,16.7,2.7,22.7 c3.6,6.4,12,10.3,12.1,10.3c0.5,0.2,0.7,0.8,0.5,1.3C17.3,42.8,16.9,43.1,16.5,43.1z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BB9158",
    d: "M16.8,11C16.8,11,16.8,11,16.8,11c-0.6,0-1-0.4-1-0.9l0.3-8.9c0-0.4,0.3-0.8,0.7-0.9s0.8,0,1.1,0.3 c1.8,2.1,4.8,3.7,9.3,4.8c0.5,0.1,0.9,0.7,0.7,1.2c-0.1,0.5-0.7,0.9-1.2,0.7C23,6.4,20.1,5.2,18,3.5l-0.2,6.6 C17.8,10.7,17.3,11,16.8,11z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BB9158",
    d: "M17,42c-0.6,0-1-0.4-1-1v-5c0-0.6,0.4-1,1-1s1,0.4,1,1v5C18,41.6,17.6,42,17,42z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.1702859ff2bc27cf3acdb403fdfb50d0.svg";
export { ForwardRef as ReactComponent };